import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import {color} from "@khanacademy/wonder-blocks-tokens";
import {mediaQueries} from "@khan/shared-styles";
import {staticUrl} from "@khan/urls";

import Parallax, {
    BreakOutLayer,
} from "#marketing-content-shared-package/parallax.tsx";

import {
    FACE_1_CLIP_1,
    FACE_1_CLIP_3,
    FACE_2_CLIP_1,
    FACE_2_CLIP_2,
    FACE_3_CLIP_1,
    FACE_3_CLIP_3,
} from "./faces.data.ts";

const Face1 = () => (
    <React.Fragment>
        <mask
            id="lohp_faces_mask0"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            height="421"
            width="340"
            x="481"
            y="45"
        >
            <path d={FACE_1_CLIP_1} fill={color.white} />
        </mask>
        <BreakOutLayer from={{x: -35, y: 0, scale: 0.85}} to={{x: 0, y: 0}}>
            <g mask="url(#lohp_faces_mask0)">
                <rect
                    fill="#fe4a54"
                    height="421"
                    width="339.5"
                    x="481"
                    y="45"
                />
                <image
                    style={{pointerEvents: "none"}}
                    href={staticUrl("/images/lohp/face1_bg_v31.jpeg")}
                    xlinkHref={staticUrl("/images/lohp/face1_bg_v31.jpeg")}
                    height="421"
                    width="339.5"
                    x="481"
                    y="45"
                />
            </g>
        </BreakOutLayer>
        <mask
            id="lohp_faces_mask1"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            height="417"
            width="335"
            x="454"
            y="45"
        >
            <path d={FACE_1_CLIP_3} fill={color.white} />
        </mask>
        <g mask="url(#lohp_faces_mask1)">
            <image
                style={{pointerEvents: "none"}}
                href={staticUrl("/images/lohp/face1_v31.jpeg")}
                xlinkHref={staticUrl("/images/lohp/face1_v31.jpeg")}
                height="414.378"
                width="334.101"
                x="453.916"
                y="46.0442"
            />
        </g>
    </React.Fragment>
);

const Face2 = () => (
    <React.Fragment>
        <mask
            id="lohp_faces_mask2"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            height="410"
            width="372"
            x="268"
            y="65"
        >
            <path d={FACE_2_CLIP_1} fill={color.white} />
        </mask>
        <BreakOutLayer from={{x: -43, y: 0, scale: 0.85}} to={{x: 0, y: 0}}>
            <g mask="url(#lohp_faces_mask2)" opacity="0.9">
                <rect
                    height="410"
                    width="371.5"
                    x="268"
                    y="65"
                    fill="#6ac9db"
                />
                <image
                    style={{pointerEvents: "none"}}
                    href={staticUrl("/images/lohp/face2_bg_v31.jpeg")}
                    xlinkHref={staticUrl("/images/lohp/face2_bg_v31.jpeg")}
                    height="410"
                    width="371.5"
                    x="268"
                    y="65"
                />
            </g>
        </BreakOutLayer>
        <mask
            id="lohp_faces_mask3"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            height="385"
            width="349"
            x="255"
            y="77"
        >
            <path d={FACE_2_CLIP_2} fill={color.white} />
        </mask>
        <g mask="url(#lohp_faces_mask3)">
            <image
                style={{pointerEvents: "none"}}
                href={staticUrl("/images/lohp/face2_v31.jpeg")}
                xlinkHref={staticUrl("/images/lohp/face2_v31.jpeg")}
                height="383.796"
                width="347.863"
                x="256.643"
                y="78.1562"
            />
        </g>
    </React.Fragment>
);

const Face3 = () => (
    <React.Fragment>
        <mask
            id="lohp_faces_mask4"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            height="576"
            width="565"
            x="31"
            y="0"
        >
            <path d={FACE_3_CLIP_1} fill={color.white} />
        </mask>
        <BreakOutLayer from={{x: -57, y: 0, scale: 0.85}} to={{x: 0, y: 0}}>
            <g mask="url(#lohp_faces_mask4)" opacity="0.8">
                <rect height="575.5" width="565" x="32" y="0" fill="#9ca5da" />
                <image
                    style={{pointerEvents: "none"}}
                    href={staticUrl("/images/lohp/face3_bg_v31.jpeg")}
                    xlinkHref={staticUrl("/images/lohp/face3_bg_v31.jpeg")}
                    height="575.5"
                    width="565"
                    x="32"
                    y="0"
                />
            </g>
        </BreakOutLayer>
        <mask
            id="lohp_faces_mask5"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            height="554"
            width="544"
            x="0"
            y="11"
        >
            <path d={FACE_3_CLIP_3} fill={color.white} />
        </mask>
        <g mask="url(#lohp_faces_mask5)">
            <image
                style={{pointerEvents: "none"}}
                href={staticUrl("/images/lohp/face3_v31.jpeg")}
                xlinkHref={staticUrl("/images/lohp/face3_v31.jpeg")}
                height="552.758"
                width="543.584"
                x="-0.000488281"
                y="11.5017"
            />
        </g>
    </React.Fragment>
);

export default class Faces extends React.PureComponent<Record<any, any>> {
    render(): React.ReactNode {
        return (
            <Parallax
                viewBox="80 0 741 520"
                width={741}
                className={css(styles.faces)}
            >
                <Face1 />
                <Face2 />
                <Face3 />
            </Parallax>
        );
    }
}

const styles = StyleSheet.create({
    faces: {
        [mediaQueries.lgOrLarger]: {
            marginLeft: "-50%",
            width: "137%",
        },
        [mediaQueries.mdOrSmaller]: {
            width: "100%",
        },
    },
});
